export default __webpack_public_path__ + "static/media/notEqualTo.d2b940ae.svg";